module.exports = __webpack_public_path__ + "img/confetti_2d.80b398b6.svg";